__turbopack_context__.v({
  "container": "FeatureShowcase-module-scss-module__Meg2vq__container",
  "fadeInUp": "FeatureShowcase-module-scss-module__Meg2vq__fadeInUp",
  "fallbackIcon": "FeatureShowcase-module-scss-module__Meg2vq__fallbackIcon",
  "featureContent": "FeatureShowcase-module-scss-module__Meg2vq__featureContent",
  "featureDescription": "FeatureShowcase-module-scss-module__Meg2vq__featureDescription",
  "featureIcon": "FeatureShowcase-module-scss-module__Meg2vq__featureIcon",
  "featureItem": "FeatureShowcase-module-scss-module__Meg2vq__featureItem",
  "featureList": "FeatureShowcase-module-scss-module__Meg2vq__featureList",
  "featureTitle": "FeatureShowcase-module-scss-module__Meg2vq__featureTitle",
  "link": "FeatureShowcase-module-scss-module__Meg2vq__link",
  "noPreview": "FeatureShowcase-module-scss-module__Meg2vq__noPreview",
  "previewFadeIn": "FeatureShowcase-module-scss-module__Meg2vq__previewFadeIn",
  "previewMedia": "FeatureShowcase-module-scss-module__Meg2vq__previewMedia",
  "previewText": "FeatureShowcase-module-scss-module__Meg2vq__previewText",
  "previewWrapper": "FeatureShowcase-module-scss-module__Meg2vq__previewWrapper",
  "progressBar": "FeatureShowcase-module-scss-module__Meg2vq__progressBar",
  "progressBarContainer": "FeatureShowcase-module-scss-module__Meg2vq__progressBarContainer",
  "videoOverlay": "FeatureShowcase-module-scss-module__Meg2vq__videoOverlay",
  "visualContainer": "FeatureShowcase-module-scss-module__Meg2vq__visualContainer",
});
